<div class="page_container">
    <ui-page-header [title]="'settings.language' | translate" [lucideIcon]="'Globe'"></ui-page-header>
    <div class="content_plan">
        <div class="content">
        <div style="display: flex;" class="container">
            <button
                class="save_btn_pop_up"
                [ngClass]="{'blue_btn': currentLanguage === 'en', 'cancel_btn_pop_up': currentLanguage !== 'en'}"
                (click)="switchLanguage('en')">
                <span>ENGLISH</span>
                <img alt="" src="../../../../../assets/icones/check_circle.svg">
            </button>
            <button
                class="save_btn_pop_up"
                [ngClass]="{'blue_btn': currentLanguage === 'fr', 'cancel_btn_pop_up': currentLanguage !== 'fr'}"
                (click)="switchLanguage('fr')">
                <span>FRANÇAIS</span>
                <img alt="" src="../../../../../assets/icones/check_circle.svg">
            </button>
            <button
                class="save_btn_pop_up"
                [ngClass]="{'blue_btn': currentLanguage === 'it', 'cancel_btn_pop_up': currentLanguage !== 'it'}"
                (click)="switchLanguage('it')">
                <span>ITALIANO</span>
                <img alt="" src="../../../../../assets/icones/check_circle.svg">
            </button>
        </div>    
    </div>
    </div>
    <div class="submet_btns">
        <button class="save_btn_pop_up cancel_btn_pop_up" (click)="close()">
        <span>{{"common.cancel"|translate}}</span>
        </button>
    </div>
</div>